import React from "react";
import { Page, Text } from "@towersystems/roam-common-native";
import { useEffect, useMemo, useState } from "react";

export interface MultipleTabGuardProps {
  children: React.ReactNode;
}

export function MultipleTabGuard({ children }: MultipleTabGuardProps) {
  const [blocked, setBlocked] = useState(false);

  const channel = useMemo(() => {
    const channel = new BroadcastChannel("roam-mobile-client");
    return channel;
  }, []);

  useEffect(() => {
    channel.postMessage("another-tab");
    channel.addEventListener("message", (msg) => {
      if (msg.data === "another-tab") {
        // message received from 2nd tab
        setBlocked(true);
      }
    });
  }, []);

  if (blocked) {
    return (
      <Page>
        <Text>Multiple Tabs Detected. Please use one.</Text>
      </Page>
    );
  }

  return <>{children}</>;
}
